<template>
    <div>
        <a-card title="Anggota Keluarga">
            <a-button v-if="getAuth.divisi[0] == 'HRD'" slot="extra" @click="showModalCreate" icon="plus">Tambah Data</a-button>
            <a-table :columns="getAuth.divisi[0] == 'HRD' ? columns : columns_non_hrd" :data-source="data.member" bordered style="margin-top: 10px;"
            :pagination="pagination" 
            :scroll="widthScreen < 400 ? { x: 1200, y:500} : { x: 1000 }"
            :loading="loading.table" size="small"
            key="tblMember" :rowKey="(record, index) => {return index;}"
            >
            <template slot="no" slot-scope="value, item, index">{{ index + 1 }}</template>
            <template slot="nama_member" slot-scope="value, item, index">
                <div style="display: flex; flex-direction: column;">
                    <span style="font-weight: bold;">{{ item.nama_member }}</span>
                </div>
            </template>
            <template slot="tgl_lahir" slot-scope="value, item, index">{{ moment(item.tgl_lahir).format("DD-MM-YYYY") }}</template>
            <template slot="keterangan" slot-scope="value, item, index">{{ item.status_member }}</template>
            <template slot="status" slot-scope="value, item, index">
                <div>
                    {{item.status == 'true' ? 'Aktif' : 'Nonaktif'}} : <a-switch size="small" :checked="item.status == 'true'" @change="val => handleDisabledChange(item, val)" />
                </div>
            </template>
            <template slot="action" slot-scope="value, item, index">
            <div style="display: flex; flex-direction: row; gap: 10px; justify-content: center;"> 
                <a-popconfirm placement="bottomRight" ok-text="Yes" cancel-text="No" @confirm="deleteMember(item)">
                    <template slot="title">
                        <p>Are you sure want to delete "{{ item.nama_member }}" ?</p>
                    </template>
                    <div>
                        <a-button :disabled="Number(item.total_klaim) > 0" shape="circle" icon="delete" />
                    </div>
                </a-popconfirm>
                <a-button shape="circle" icon="edit" @click="editMember(item)"/>
            </div>
            </template>
            </a-table>
        </a-card>

        <a-modal
        :dialog-style="{ top: '20px' }"
        :title="modalTitle"
        :visible="visibleModal"
        @cancel="closeModal"
        >
        <a-form class="m-form" :form="form">
            <a-form-item label="NIK">
                <a-input
                autocomplete="off"
                v-decorator="[
                    'nik_member',
                    { rules: [{ required: true, message: 'NIK is required!' }] }
                ]"
                />
            </a-form-item>

            <a-form-item label="Nama Lengkap">
                <a-input
                autocomplete="off"
                v-decorator="[
                    'nama_member',
                    { rules: [{ required: true,message: 'Nama Lengkap is required!' }] }
                ]"
                />
            </a-form-item>

            <a-form-item label="Tanggal Lahir">
                <a-date-picker
                class="w-full"
                :format="getDefaultDateFormat"
                v-decorator="[
                    'tgl_lahir_member',
                    {
                    rules: [{ required: true, message: 'Tanggal Lahir is required!' }]
                    }
                ]"
                />
            </a-form-item>

            <a-form-item label="Jenis Kelamin">
                <a-select
                v-decorator="[
                    'gender_member',
                    { rules: [{ required: true, message: 'Jenis Kelamin is required!' }] }
                ]"
                >
                <a-select-option key="pria" value="laki-laki"
                    >Laki - Laki</a-select-option
                >
                <a-select-option key="perempuan" value="perempuan"
                    >Perempuan</a-select-option
                >
                </a-select>
            </a-form-item>

            <a-form-item label="Status Hubungan Dalam Keluarga">
                <a-select
                v-decorator="[
                    'status_member',
                    { rules: [{ required: true, message: 'Status is required!' }]}
                ]"
                >
                <a-select-option v-for="s in combo_status" :key="s.key" :value="s.name">{{ s.name }}</a-select-option>
                </a-select>
            </a-form-item>
        </a-form>

        <template slot="footer">
            <a-button key="back" @click="closeModal">Cancel</a-button>
            <a-button
            v-if="modalMode == 'create'"
            key="submit"
            type="primary"
            :loading="loading.add"
            @click="handleSubmitAdd"
            >Submit</a-button>

            <a-button
            v-if="modalMode == 'edit'"
            key="submit"
            type="primary"
            :loading="loading.save"
            @click="handleUpdateSubmit"
            >Save</a-button>
        </template>
        </a-modal>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import moment from "moment-business-days"

const columns = [
    {
        title: 'No',
        width: 40,
        className: 'center',
        scopedSlots: { customRender: 'no' },
    },
    {
        title: 'Nama',
        width: 200,
        dataIndex: 'nama_member',
        scopedSlots: { customRender: 'nama_member' },
    },
    {
        title: 'Tanggal Lahir',
        dataIndex: 'tgl_lahir',
        className: 'center',
        scopedSlots: { customRender: 'tgl_lahir' },
    },
    {
        title: 'NIK',
        dataIndex: 'nik',
        className: 'center',
        scopedSlots: { customRender: 'nik' },
    },
    {
        title: 'Jenis Kelamin',
        dataIndex: 'jenis_kelamin',
        className: 'center',
        scopedSlots: { customRender: 'jenis_kelamin' },
    },
    {
        title: 'Status Hubungan Dalam Keluarga',
        dataIndex: 'jns_member',
        className: 'center',
        scopedSlots: { customRender: 'jns_member' },
    },
        {
        title: 'Status',
        dataIndex: 'status',
        className: 'center',
        scopedSlots: { customRender: 'status' },
    },
    {
        title: 'Action',
        className: 'center',
        scopedSlots: { customRender: 'action' },
    },
];
const columns_non_hrd = [
    {
        title: 'No',
        width: 40,
        className: 'center',
        scopedSlots: { customRender: 'no' },
    },
    {
        title: 'Nama',
        width: 200,
        dataIndex: 'nama_member',
        scopedSlots: { customRender: 'nama_member' },
    },
    {
        title: 'NIK',
        dataIndex: 'nik',
        className: 'center',
        scopedSlots: { customRender: 'nik' },
    },
    {
        title: 'Jenis Kelamin',
        dataIndex: 'jenis_kelamin',
        className: 'center',
        scopedSlots: { customRender: 'jenis_kelamin' },
    },
    {
        title: 'Keterangan',
        dataIndex: 'jns_member',
        className: 'center',
        scopedSlots: { customRender: 'jns_member' },
    }
];
const combo_status = [
    { key: "istri", name: "Istri" },
    { key: "suami", name: "Suami" },
    { key: "anak1", name: "Anak 1" },
    { key: "anak2", name: "Anak 2" },
    { key: "anak3", name: "Anak 3" },
    { key: "anak4", name: "Anak 4" },
    { key: "anak5", name: "Anak 5" },
    { key: "anak6", name: "Anak 6" },
    { key: "anak7", name: "Anak 7" },
    { key: "anak8", name: "Anak 8" },
    { key: "anak9", name: "Anak 9" }
];

export default {
    name: "anggota-keluarga",
    props: ["data"],
    data(){
        return {
            columns,
            columns_non_hrd,
            moment,
            combo_status,
            widthScreen: 0,
            heighScreen: 0,
            pagination: {},
            listData: [],
            rawData: [],
            loading: {
                table: false,
                save: false,
                add: false
            },
            visibleModal: false,
            modalMode: '',
            editId: '',
            modalTitle: '',
            statusMember: false
        }
    },

    computed: {
        ...mapGetters(["getDefaultDateFormat", "getMaster", "getAuth"])
    },

    beforeCreate(){
        this.form = this.$form.createForm(this);
    },

    mounted(){
        this.widthScreen = window.innerWidth
        this.heighScreen = window.innerHeight
        console.log(this.data.member);
        // this.listData = this.data.member ? this.data.member : []
        if (this.data && Array.isArray(this.data.member)) {
            this.listData = this.data.member
        }
        this.rawData = this.data
        // Event.$emit("fetching", true);
    },

    methods: {
        async deleteMember(value){
            const payload = {
                id : value.id_member,
                tlc: this.rawData.profile.tlc,
            }

            try {
                const response = await this.asyncAxiosDelete("master_karyawan/remove_family", "json", this.getAuth, payload)
                console.log(response);
                
                if(response.status){
                    const new_arr = this.listData.filter((d) => d.id_member !== value.id_member)
                    this.listData = new_arr
                    Event.$emit("updateMember", this.listData);
                    this.displayMessageValue("success-basic", "Data member berhasil dihapus");
                    Event.$off("updateMember", this.listData);
                }
            } catch (error) {
                console.log(error);
            }
            
        },

        dateLong(date){
            return moment(date).format("MM-DD-YYYY")
        },

        editMember(value){
            this.modalMode = 'edit'
            this.modalTitle = 'Ubah Data Anggota'

            this.$nextTick(() => {
                this.form.setFieldsValue({
                    nik_member: value.nik,
                    nama_member: value.nama_member,
                    tgl_lahir_member: moment(value.tgl_lahir).format("YYYY-MM-DD"),
                    gender_member: value.jenis_kelamin,
                    status_member: value.jns_member
                })
            })
            this.editId = value.id_member
            this.visibleModal = true
        },

        closeModal(){
            this.visibleModal = false
        },

        async handleDisabledChange(item, val){
            console.log(item, val);

            try {
                const payload = {
                    id_member: item.id_member,
                    status: val
                }
                const response = await this.asyncAxiosPut('master_karyawan/change_status_member', "json", this.getAuth, payload)
                if(response.status){
                    const dt = this.listData.find((val) => val.id_member == item.id_member)
                    if(dt){
                        dt.status = String(val);
                    }

                    this.displayMessageValue("success-basic", "Data member berhasil diubah");
                }
            } catch (error) {
                console.log(error);
            }
        },

        handleUpdateSubmit(){
            this.loading.save = true
            this.form.validateFields( async (err, values) => {
                if(err){
                    this.displayMessage("form-warning");
                    this.loading.save = false
                    return;
                }
                
                const payload = {
                    id: this.editId,
                    nama_member: values.nama_member,
                    nik: values.nik_member,
                    tgl_lahir: this.dateFormat(values.tgl_lahir_member),
                    gender: values.gender_member,
                    status_member: values.status_member,
                    tlc: this.rawData.profile.tlc
                }

                try {
                    const response = await this.asyncAxiosPut("master_karyawan/edit_family", "json", this.getAuth, payload)
                    console.log(response);  
                    if(response.status){
                        this.listData = response.data

                        this.displayMessageValue("success-basic", "Data member berhasil disimpan");
                        this.closeModal()
                        this.form.resetFields()
                        Event.$emit("updateMember", this.listData);
                        // const item = this.listData.find((d) => d.id_member === response.data.id_member)
                        // if(item){
                        //     item.nama_member = response.data.nama_member
                        //     item.nik = response.data.nik
                        //     item.jenis_kelamin = response.data.jenis_kelamin
                        //     item.jns_member = response.data.jns_member   
                        // }
                        
                        // Event.$emit("fetching", true);
                    }
                this.loading.save = false
                } catch (error) {
                    console.log(error);
                    this.loading.save = false
                }
            })
        },

        showModalCreate(){
            this.modalMode = 'create'
            this.modalTitle = 'Tambah Data Anggota'
            this.visibleModal = true
            this.form.resetFields()
        },

        dateFormat(date){
            // return date.toISOString().split("T")[0]
            const d = new Date(date);
            const year = d.getFullYear();
            const month = String(d.getMonth() + 1).padStart(2, '0'); // bulan mulai dari 0
            const day = String(d.getDate()).padStart(2, '0');
            return `${year}-${month}-${day}`;
        },

        handleSubmitAdd(){
            this.loading.add = true
            this.form.validateFields( async (err, values) => {
                if(err){
                    this.displayMessage("form-warning");
                    this.loading.add = false
                    return;
                }

                const payload = {
                    tlc: this.rawData.profile.tlc,
                    nama_member: values.nama_member,
                    nik: values.nik_member,
                    tgl_lahir: this.dateFormat(values.tgl_lahir_member),
                    jenis_kelamin: values.gender_member,
                    status: values.status_member
                }

                try {
                    const response = await this.asyncAxiosPost("master_karyawan/add_member", "json", this.getAuth, payload)
                    if(response){
                        this.displayMessageValue("success-basic", "Data member berhasil disimpan");
                        Event.$emit("updateMember", response.data);
                        this.listData = response.data
                        this.closeModal()
                        this.loading.add = false
                    }
                    this.loading.add = false
                } catch (error) {
                    console.log(error);
                    this.loading.add = false
                }
            })
        }
    }
}
</script>